
<template>
    <div id="downloadbleCard">
        <div class="card my-4">
            <div class="image-container">
                <img class="d-block d-lg-none" :src="resolvedImageMobileSrc" :alt="altName" />
                <img class="d-none d-lg-block" :src="resolvedImageDesktopSrc" :alt="altName" />
            </div>
            <div class="content ml-3 pt-4 pt-lg-0">
                <h3 class="title">{{ title }}</h3>
                <p class="description" v-html="description"></p>
            </div>
            <div class="buttons mx-3 mx-lg-2 pb-4 pb-lg-0">
                <a target="_blank" :href="downloadLink" class="button" :title="downloadTitle">
                    <label class="m-0 mr-2 ">Download</label>
                    <div>
                        <svg xmlns="http://www.w3.org/2000/svg" width="17.362" height="17.362" viewBox="0 0 17.362 17.362">
                            <path id="download_24dp_5F6368_FILL0_wght400_GRAD0_opsz24"
                                d="M168.681-786.978l-5.426-5.426,1.519-1.573,2.821,2.821V-800h2.17v8.844l2.821-2.821,1.519,1.573Zm-6.511,4.341a2.09,2.09,0,0,1-1.533-.638,2.09,2.09,0,0,1-.638-1.533v-3.255h2.17v3.255h13.022v-3.255h2.17v3.255a2.09,2.09,0,0,1-.638,1.533,2.09,2.09,0,0,1-1.533.638Z"
                                transform="translate(-160 800)" fill="#fff" />
                        </svg>
                    </div>
                </a>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        imageDesktopSrc: {
            type: String,
            default: "resources/res1.png"
        },
        imageMobileSrc: {
            type: String,
            default: "resources/res1-m.png"
        },
        title: {
            type: String,
            default: "Pharmacy instructions"
        },
        description: {
            type: String,
            default: "Follow these tips to help with processing the JORNAY PM savings card"
        },
        downloadLink: {
            type: String,
            default: "/pharmacy-instructions.pdf"
        },
        downloadTitle: {
            type: String,
            default: ""
        },
        altName: {
            type: String,
            default: "Pharmacy Instructions brochure"
        }
    },
    computed: {
        resolvedImageDesktopSrc() {
            try {
                return require(`@/assets/img/${this.imageDesktopSrc}`);
            } catch (e) {
                return "";
            }
        },
        resolvedImageMobileSrc() {
            try {
                return require(`@/assets/img/${this.imageMobileSrc}`);
            } catch (e) {
                return "";
            }
        }
    },
    mounted() {
        console.log(this.altName);
    },
};
</script>